<template>
  <svg width="102.75" heihgt="59.29" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.75 59.29"><path d="M84.17 59.29H17.43a17.43 17.43 0 0 1 0-34.86h.92a17.36 17.36 0 0 1 17.09-14.22 17.18 17.18 0 0 1 6.31 1.26A22.39 22.39 0 0 1 61 0a22 22 0 0 1 21.9 21.9v.46h1.15a18.46 18.46 0 1 1 .11 36.93" fill-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'CloudLeft'
}
</script>
